// import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import { ptBR } from "date-fns/locale";
// import DateFnsUtils from "@date-io/date-fns";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

const TextFieldDateTime = (props) => {
  const { value } = props;
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          format="DD/MM/YYYY HH:mm"
          ampm={false}
          {...props}
          value={dayjs(value)}
        />
      </LocalizationProvider>

      {/* <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <DateTimePicker
          size="small"
          ampm={false}
          minutesStep={60}
          variant="outlined"
          margin="normal"
          label={label}
          value={value}
          onChange={handleDateTimeChange}
        />
      </MuiPickersUtilsProvider> */}
    </>

  );
};

export default TextFieldDateTime;
